import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useListingContext } from '@/context/listing';

import FilterItem from '@/listing-delonghi/components/filters/FilterItem';
import FilterColorItem from '@/listing-delonghi/components/filters/FilterColorItem';

const FiltersMenuMobile = ({ toggleFilters, filtersData }) => {
  const { t } = useTranslation();

  const { facets } = filtersData;
  const facetElements = facets.map(facet =>
    facet.code === 'baseColor' ? (
      <FilterColorItem filter={facet} key={facet.code} />
    ) : (
      <FilterItem filter={facet} key={facet.code} />
    ),
  );

  // Updating query and resetting url on clear all filters
  const [{ selectedFiltersCount }, { clearFilters }] = useListingContext();

  return (
    <div className='del-plp-filters__filters-menu-mobile'>
      <div
        className={`del-plp-filters__filters-menu-mobile-close-row ${
          selectedFiltersCount
            ? `del-plp-filters__filters-menu-mobile-close-row--with-filters`
            : ''
        }`}
      >
        {selectedFiltersCount ? (
          <button
            type='button'
            className='del-button del-plp-filters__filters-clear-all js-filter-removeall'
            onClick={clearFilters}
          >
            {t('listing:listing.clear.filters.cta.label')}
          </button>
        ) : null}
        <button
          type='button'
          className='del-button del-plp-filters__filters-menu-mobile-close'
          onClick={toggleFilters}
        >
          <i className='del-icon icon-menu-close del-plp-filters__filters-menu-mobile-close-icon' />
        </button>
      </div>
      <div className='del-plp-filters__filters-wrapper'>{facetElements}</div>
      <div className='del-plp-filters__filters-apply-row'>
        <button
          type='button'
          className='del-button del-button--primary-black del-button--mid del-plp-filters__filters-menu-mobile-apply'
          onClick={toggleFilters}
        >
          {t('listing:listing.apply.filters.cta.label')}
        </button>
      </div>
    </div>
  );
};

FiltersMenuMobile.propTypes = {
  toggleFilters: PropTypes.func.isRequired,
  filtersData: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default FiltersMenuMobile;
